'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reselect = require('reselect');

var getIsElectron = function getIsElectron() {
    return process.env.APPLICATION_MODE === 'electron';
};

exports.default = (0, _reselect.createStructuredSelector)({
    isElectron: getIsElectron
});


//////////////////
// WEBPACK FOOTER
// ./src/client/components/electron/electronSelector.js
// module id = 692
// module chunks = 0